import {Command} from './Command';
import {AddWallAction} from '../actions';
import {StageService} from '../../stage.service';
import {RailingGenerationService} from '../../railing/services/railing-generation.service';

export class AddWallCommand extends Command<AddWallAction> {

  private uuid;

  constructor(
    private stage: StageService,
    private railingGenerationService: RailingGenerationService
  ) {
    super();
  }

  do(action: AddWallAction) {
    this.uuid = action.wallUuid;
  }

  undo() {
    const wall = this.stage.findObject(obj => obj.userData.uuid === this.uuid);
    this.stage.remove(wall);
    const firstPoint = wall.userData.config.firstPoint;
    firstPoint.superstructureType = null;
    firstPoint.distance = null;
    firstPoint.superstructureId = null;
    firstPoint.floor = null;
    this.railingGenerationService.buildRailing(this.railingGenerationService.IsVisible());
  }

}



// WEBPACK FOOTER //
// ./src/app/services/eventLog/commands/AddWallCommand.ts